<template>
	<section class="tp-History">
		<ClientHistoryTableReact
			:repairs="repairs"
			:loading="loading"
			class="tp-History__table"
		/>

		<!-- pagination ------------------------------------------------------ -->
		<el-pagination
			:current-page="curPage"
			:total="total"
			:page-size="20"
			class="tp-History__pagination"
			layout="prev, pager, next"
			@current-change="fetchPage"
		/>
	</section>
</template>

<script>
import { mapGetters } from "vuex";

import ReactInVue from "@/components/logic/wrappers/ReactInVue";
import { ClientHistoryTable } from "@/components/clientDash/ClientHistoryTable";

const ClientHistoryTableReact = ReactInVue(ClientHistoryTable);

export default {
	components: {
		ClientHistoryTableReact,
	},

	data() {
		return {
			repairs: [],
			total: 0,
			curPage: 0,
			loading: false,
		};
	},
	computed: {
		...mapGetters(["user"]),
	},
	created() {
		// fetch first page
		this.fetchPage();
	},
	methods: {
		logs(log) {
			const entry = log.filter((item) => item.title === "Novo orçamento")[0];

			// when there is no quotation return an hiphen
			if (!entry) {
				return "-";
			}

			const exp = /.*-\s(.*)\s-.*/;

			try {
				return entry.content.match(exp)[1];
			} catch (e) {
				return "-";
			}
		},
		async fetchPage(page = 1) {
			// enable loading
			this.loading = true;

			// cal the API to fetch data
			const { total, data } = await this.$stellar.action("paginateRepairs", {
				client: this.user.personId,
				page,
				limit: 20,
				states: ["delivered"],
			});

			// disable loading
			this.loading = false;

			// store data
			this.total = total;
			this.repairs = data;
		},
	},
};
</script>

<style lang="scss">
.tp-History {
	padding: 10px 0;

	&__table {
		max-width: 98%;
		margin: 0 auto;
	}

	&__value {
		font-size: 1.5rem;
	}

	&__pagination {
		margin: 8px 0 8px 9px;
	}
}
</style>
